import { Pipe, PipeTransform } from '@angular/core';
import { App_formDoc, DocEditable, DocEditable2, DocumentElaborationForm } from '../../utils/interfaces';
import { AbstractControl, FormArray, FormControl } from '@angular/forms';

@Pipe({
  name: 'documentsLevagesEditablesPipe'
})
export class DocumentsLevagesEditablesPipe implements PipeTransform {

  transform(documentsLevage: App_formDoc[], documentsLevageHandlingForm: FormArray<FormControl<DocumentElaborationForm>> | undefined, documentsLevageHandlingFormValue: any): DocEditable[] {
    const documentsLevagesAsDocEditable: DocEditable2[] = documentsLevage.map(documentLevage => ({
      doc: documentLevage
    }));
    if (documentsLevageHandlingForm) {
      const controls = documentsLevageHandlingForm.controls;
      if (Array.isArray(controls)) {
        return controls.reduce<DocEditable[]>((docsEditables, control) => {
          const value = control?.value;
          const filename = value?.filename;
          const foundIndex = docsEditables.findIndex(docEditable => typeof docEditable.doc?.title === 'string' && docEditable.doc?.title === filename);
          if (foundIndex !== -1) {
            return [
              ...docsEditables.slice(0, foundIndex),
              {
                doc: docsEditables[foundIndex].doc,
                docInForm: control
              },
              ...docsEditables.slice(foundIndex + 1),
            ]
          } else {
            return [
              ...docsEditables,
              {
                docInForm: control
              }
            ]
          }
        }, documentsLevagesAsDocEditable)
      }
    }
    return documentsLevagesAsDocEditable;
  }

}

@Pipe({
  name: 'documentsLevagesEditablesEnCoursPipe'
})
export class DocumentsLevagesEditablesEnCoursPipe implements PipeTransform {

  transform(docsEditables: DocEditable[]): DocEditable[] {
    return docsEditables.filter(docEditable => docEditable.docInForm === undefined || docEditable.docInForm?.value?.delete !== 1)
  }

}

@Pipe({
  name: 'documentsLevagesEditablesASupprimerPipe'
})
export class DocumentsLevagesEditablesASupprimerPipe implements PipeTransform {

  transform(docsEditables: DocEditable[]): DocEditable[] {
    return docsEditables.filter(docEditable => docEditable.docInForm instanceof AbstractControl && docEditable.docInForm?.value?.delete === 1)
  }

}

@Pipe({
  name: 'getDocumentLevageEditableTitlePipe'
})
export class GetDocumentLevageEditableTitlePipe implements PipeTransform {

  transform(docEditable: DocEditable): string {
    return docEditable.doc?.title || docEditable.docInForm?.value.filename || '';
  }

}
